module.exports = __webpack_public_path__ + "static/media/engineOutline.c9de05be.svg";